export default {
  statusReason_OUTGOING_DELIVERY_FAILED:
    'Your provider failed to deliver this message.',
  statusReason_OUTGOING_SEND_FAILED:
    'Your provider failed to send this message.',
  statusReasonLabel: 'Reason:'
};
